// Card with some congratulations about a payment

import { useNavigate } from 'react-router-dom';
import Card from './Card';
import './PaymentSuccessCard.scss';

export default function PaymentSuccessCard() {
  const navigate = useNavigate();

  return (
    <Card header='Payment successful' className='payment-success-card'>
      <p className='font-16'>Your payment has been processed successfully</p>
      <button onClick={() => navigate('/login')}>Ok</button>
    </Card>
  );
}
